import { connect } from 'react-redux';
import Tunggakan from '../../../../views/Finance/Spp/Tunggakan/Tunggakan.view';
import { listArrearsStudents, listArrearsClasses, listArrearsAccumulations } from '../../../../states/thunks/academics.thunk';
import { getParamOptionsAcademics, getYearsOfEducationsOptions, getStudentOptions, getPeriodsOptions } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  }
}
function mapDispatchToProps(dispatch) {
  return {
    handleListArrearsStudents: (payload, goback) => dispatch(listArrearsStudents(payload, goback)),
    handleListArrearsClasses: (payload, goback) => dispatch(listArrearsClasses(payload, goback)),
    handleListArrearsAccumulations: (payload, goback) => dispatch(listArrearsAccumulations(payload, goback)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    getYearsOfEducationsOptions: (payload) => dispatch(getYearsOfEducationsOptions(payload)),
    getStudentOptions: (payload) => dispatch(getStudentOptions(payload)),
    getPeriodsOptions: (payload) => dispatch(getPeriodsOptions(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tunggakan);
